import { Editorial } from './Editorial';
import { Personal } from './Personal';
export const versions = [
    Editorial,
    Personal
];
export * from './Quotations.abstract';
